import { ParentNavigationItem } from "~/pages/Treasury/Sidebar/types";
export const SIDEBAR_TREASURY_BASE_ITEMS: ParentNavigationItem[] = [
  {
    title: "Transactions",
    paths: ["/treasury/transactions"],
    iconType: "receipt",
  },
  {
    title: "Payments",
    paths: ["/treasury/payments", "/treasury"],
    iconType: "money-bill-transfer",
  },
  {
    title: "Payees",
    paths: ["/treasury/payees"],
    iconType: "address-book",
  },
];
